import ComponentsFactory from 'foundation/components-factory';
import ContextualStats from './js/contextual-stats.component';

ComponentsFactory.getInstance().define('contextual-stats', ContextualStats);
